export default {
      id: "ar_restaurant-usage",
      viewBox: "0 0 230 150",
      url: "../dist/images/" + "sprite.svg#ar_restaurant-usage",
      toString: function () {
        return this.url;
      }
    }